import { TimeSpentBar } from './TimeSpentBar';
import type { TimeSpentCellValue } from './timeSpentColumn.utils';

interface TimeSpentCellProps {
  value: TimeSpentCellValue;
  rowIndex: number;
  maxPercent: number;
}

export function TimeSpentCell({ value, rowIndex, maxPercent }: TimeSpentCellProps) {
  if (value === 'loading') {
    return (
      <div aria-hidden="true" className="h-[calc(var(--hm-row)-1px)] px-2 py-1.5">
        <div
          className="rail-skeleton h-full"
          style={{ width: `${30 + ((rowIndex * 37) % 60)}%` }}
        />
      </div>
    );
  }

  if (value === 'unavailable') {
    return <div className="pl-2 font-mono text-[12.5px] text-dim min-[721px]:text-[13.5px]">–</div>;
  }

  return <TimeSpentBar percent={value} maxPercent={maxPercent} />;
}
